/**
 * @fileoverview
 * CSRF Token Interceptor - Captures CSRF tokens from response headers
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { HttpInterceptorFn, HttpEvent, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { TokenService } from '../services';

export const csrfInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);

  return next(req).pipe(
    tap((event: HttpEvent<any>) => {
      // Check if response has CSRF token header
      if (event instanceof HttpResponse) {
        const csrfToken = event.headers.get('X-CSRF-Token') || event.headers.get('x-csrf-token');
        if (csrfToken) {
          tokenService.setCsrfToken(csrfToken);
        }
      }
    })
  );
};

